module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4mrwg"))).then(() => parcelRequire('hEqeo'));